import React, { useContext, useCallback } from 'react';
import { switchCurrentlyUsedSheet } from './research-sheet-api';
import { ResearchSheet as ResearchSheetType } from 'types';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { AuthCtx } from 'components/auth/auth-ctx';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';
import { ResearchSheetState } from 'enums';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    link: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  })
);

export function PrimaryCellComponent({
  data,
  allData,
}: {
  data: any;
  allData: any;
}) {
  const classes = useStyles();

  const row = allData as ResearchSheetType;
  const { userInfo, refreshUser } = useContext(AuthCtx);
  const { showNotification } = useContext(NotificationCtx);

  const isPrimary = userInfo?.currentlyUsedSheetId === row.id;
  const isValidResearchSheet = row.state === ResearchSheetState.ACTIVE;

  const handleSwitchCurrentlyUsedSheet = useCallback(async () => {
    try {
      await switchCurrentlyUsedSheet(row.id);

      // refreshList();
      refreshUser();

      showNotification(
        'Badatelský list byl úspěšne nastaven jako primární.',
        NotificationVariant.SUCCESS
      );
    } catch (e) {
      console.log(e);

      showNotification(
        `Badatelský list se nezdařilo nastavit jako primární.
        
      Chyba: ${e?.message ?? '-'}

      Kód: ${e?.code}`,
        NotificationVariant.ERROR
      );
    }
  }, [refreshUser, showNotification, row.id]);

  return isPrimary ? (
    <CheckBoxIcon color="primary" />
  ) : isValidResearchSheet ? (
    <Typography
      onClick={handleSwitchCurrentlyUsedSheet}
      color="primary"
      className={classes.link}
    >
      Nastavit jako primární
    </Typography>
  ) : (
    <></>
  );
}
